import { render, staticRenderFns } from "./employeesLanding.vue?vue&type=template&id=35b89434&scoped=true&"
import script from "./employeesLanding.vue?vue&type=script&lang=js&"
export * from "./employeesLanding.vue?vue&type=script&lang=js&"
import style0 from "./employeesLanding.vue?vue&type=style&index=0&id=35b89434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b89434",
  null
  
)

export default component.exports